module.exports = function() {
  return new Worker(__webpack_public_path__ + "29bd4767ebdefb2142e8.worker.js");
};